import type { SubjectPack } from "./ai_literacy/subjectPack.js";
import { AI_LITERACY_PACK } from "./ai_literacy/subjectPack.js";
import { FIRST_AID_PACK } from "./first_aid/subjectPack.js";
import { NOTANY_PACK } from "./notany/subjectPack.js";
import { EPSO_AD8_AI_PACK } from "./epso_ad8_ai/subjectPack.js";

export const SUBJECTS: Readonly<Record<string, SubjectPack>> = {
  ai_literacy: AI_LITERACY_PACK,
  first_aid: FIRST_AID_PACK,
  notany: NOTANY_PACK,
  epso_ad8_ai: EPSO_AD8_AI_PACK,
};

export const SUBJECT_IDS = Object.keys(SUBJECTS) as (keyof typeof SUBJECTS & string)[];

export function getSubjectPack(id: string): SubjectPack | undefined {
  return SUBJECTS[id];
}

export function defaultSubjectId(): string {
  return "ai_literacy";
}
